import React from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/sections/Hero";
import WhyGermany from "@/components/sections/WhyGermany";
import WhyElecars from "@/components/sections/WhyElecars";
import Inspection from "@/components/sections/Inspection";
import HowItWorks from "@/components/sections/HowItWorks";
import Categories from "@/components/sections/Categories";
import Trust from "@/components/sections/Trust";
import Benefits from "@/components/sections/Benefits";
import Testimonials from "@/components/sections/Testimonials";
import FAQ from "@/components/sections/FAQ";
import FinalCTA from "@/components/sections/FinalCTA";
import Contact from "@/components/sections/Contact";
import Footer from "@/components/Footer";
import WhatsAppFab from "@/components/WhatsAppFab";

export default function LandingPage() {
  return (
    <div className="relative bg-[#0A0A0A] text-[#FFFFF0] overflow-x-hidden" data-testid="landing-page">
      <Navbar />
      <main>
        <Hero />
        <WhyGermany />
        <WhyElecars />
        <Inspection />
        <HowItWorks />
        <Categories />
        <Trust />
        <Benefits />
        <Testimonials />
        <FAQ />
        <FinalCTA />
        <Contact />
      </main>
      <Footer />
      <WhatsAppFab />
    </div>
  );
}
